




















import { Component, Emit, Inject, Model, Prop } from "vue-property-decorator";
import { Provide, Watch, Vue } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import GeneralUtilsHelper from "@/utils/generalUtils";
import VipOfferUtils from "@/utils/vipOfferUtils";
import * as types from "@/store/constants/types";

@Component({
  components: {}
})
export default class VipButton extends Vue {
  @Getter(types.GETTER_SETTING_DATA)
  private settingData: any;
  @Prop({ default: true })
  private type!: boolean;
  @Prop({ default: '' })
  private pageFrom!: any;

  get mainStr() {
    return this.buttonContents.main;
  }

  get subStr() {
    return this.buttonContents.sub;
  }

  get bonusStr() {
    return this.buttonContents.bonus;
  }

  get isCoin() {
    return this.buttonContents.hasOwnProperty("bonusType")
      ? this.buttonContents.bonusType === "coin"
      : false;
  }

  get selectOffer() {
    return VipOfferUtils.firstVipService();
  }

  get buttonContents() {
    return VipOfferUtils.vipButtonContents(this.selectOffer);
  }

  private clickButton() {
    this.$emit("click");
  }

  private mounted() {
    console.log(this.pageFrom)
  }

  private beforeDestroy() {}
}
